export default "__VITE_ASSET__QUMuuCrR__"